import { render, staticRenderFns } from "./datatables.vue?vue&type=template&id=6b3453a6&"
import script from "./datatables.vue?vue&type=script&lang=js&"
export * from "./datatables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports